import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { UserService } from '../../../../services/api/user.service';
import { RouteService } from '../../../../services/route.service';
import { CategoriesService } from '../../../../services/api/general-settings/categories.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';

@Component({
  selector: 'app-category-index',
  imports: [BaseIndexPageComponent,],
  templateUrl: './category-index-page.component.html',
  styleUrl: './category-index-page.component.scss'
})
export class CategoryIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected categoriesService: CategoriesService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Categories',
      cardTitle: 'Manage Categories',
      addNewItemButton: {
        type: 'success',
        title: 'Add Category',
        onClick: () => {
          this.routeService.categoryCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View category details',
                onClick: (item: any) => {
                  this.routeService.categoryDetail(item.categoryId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit category',
                onClick: (item: any) => {
                  this.routeService.categoryUpdate(item.categoryId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete category',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((category: any) => category.categoryId !== item.categoryId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.categoriesService.list(options),
      responseListModelName: 'categories',
    }
  }  
}
